import * as coreCommon from 'assets/core/js/common'
import Modal from 'assets/core/js/module/modal'

const modals: Record<string, Modal> = {}

export const initTabs = function (ref: HTMLElement): void {
  ref.querySelectorAll('.dca-payment-facilities__wrapper .dca-payment-facilities__tabs a').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault()

      const wrapper = el.closest('.dca-payment-facilities__wrapper') as Element

      wrapper.querySelector('.dca-payment-facilities__tab--active')?.classList.remove('dca-payment-facilities__tab--active')
      wrapper.querySelector('.dca-payment-facilities__content--active')?.classList.remove('dca-payment-facilities__content--active')

      el.classList.add('dca-payment-facilities__tab--active')
      wrapper
        .querySelector(`.dca-payment-facilities__content[data-content="${el.getAttribute('href')?.replace('#', '') as string}"]`)
        ?.classList.add('dca-payment-facilities__content--active')
    })
  })
}

export const initModal = function (): void {
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement

    if (target.matches('.dca-payment-facilities')) {
      e.preventDefault()

      const url = target.getAttribute('data-url') as string

      let modal: Modal

      if (!modals[url]) {
        const modalEl = target.parentNode?.querySelector<HTMLElement>('.dca-payment-facilities__modal')

        if (!modalEl) {
          return
        }

        modal = new Modal(modalEl, {
          onClose: () => {
            if (xhrRequest) {
              xhrRequest.abort()
            }
          },
        })

        const xhrRequest = coreCommon.createXhr('GET', url)

        xhrRequest.onreadystatechange = () => {
          if (xhrRequest.readyState === XMLHttpRequest.DONE && xhrRequest.status === 200) {
            modals[url] = modal
            modal.setContent(xhrRequest.response as string)
            initTabs(modalEl)
          } else if (xhrRequest.readyState === XMLHttpRequest.DONE && xhrRequest.status === 500) {
            modal.close()
          }
        }

        xhrRequest.send()
        modal.open()
      } else {
        modal = modals[url]
        modal.open()
      }
    }
  })
}
